import AxiosConfig from "./AxiosConfig";

export const commentCheck = async (comment, onSuccess = () => {}, onError = () => {}) => {
    try {
        const response = await AxiosConfig.post(`/admin/comments/${comment.id}/check`, {check: !comment.check});
        if (response.data.success) {
            onSuccess(response);
        } else {
            onError(response.data.message);
        }
    } catch (error) {
        onError(error);
    }
}

export const commentAdd = async (newComment, handleError, handleSuccess, setSubmitting, url, setNewComment, setShowAddForm, toggleComments) => {
    if (!newComment.title.trim()) {
        handleError("Un titre est obligatoire");
        return;
    }

    setSubmitting(true);
    try {
        const response = await AxiosConfig.post(url, {
            title: newComment.title,
            text: newComment.text || null,
            dateNotif: newComment.dateNotif || null,
            check: newComment.check,
        });

        if (response.data.success) {
            handleSuccess(response.data.message);
            setNewComment({ title: '', text: '', dateNotif: '', check: null });
            setShowAddForm(false);
            toggleComments(); // refresh la liste
        } else {
            handleError("Erreur : " + response.data.message);
        }
    } catch (error) {
        console.error('error', error);
        handleError();
    } finally {
        setSubmitting(false);
    }
};

export const toggleComments = async (url, setComments, handleError) => {
    try {
        const response = await AxiosConfig.get(url);
        if (response.data.success) {
            setComments(response.data.data);
        } else {
            console.error("error", response);
            handleError(response.data.message);
        }
    } catch (error) {
        console.error("error", error);
        handleError();
    }
};